import React from "react";
import CancelIcon from "./icons/CancelIcon";
import * as styles from "./BVReject.css"

export class BVReject extends React.Component {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.rejectIcon}>
                    <CancelIcon />
                </div>
                <h2 className={styles.header}>Вы уже отправили отзыв. Спасибо!</h2>
            </div>
        );
    }
}